<template>
    <div>
        <div :class="['video-item', imgSize]" @click="toDetails(video.newsId)">
            <img :src="video.newsImage" alt="">
            <div class="video-info">
                <h3 v-if="imgSize !== 'small' && isPc != 3">{{ video.newsTitle }}</h3>
                <div class="video-type">
                    <svg-icon icon-class="play" color="#FFFFFF" />
                    <span>{{ video.videoTime ? video.videoTime : '13:20' }}</span>
                </div>
            </div>
        </div>
        <div class="video-title" v-if="imgSize === 'small' || isPc == 3">{{ video.newsTitle }}</div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: 'VideoItem',
    props: {
        video: {
            type: Object,
            default: () => { }
        },
        imgSize: {
            type: String,
            default: 'middle'
        }
    },
    computed: {
        ...mapState(["isPc"]),
    },
    methods: {
        toDetails(id) {
            this.$router.push({ path: '/video-details/' + id })
        }
    }
}
</script>

<style lang="less" scoped>
.video-item {
    width: 100%;
    height: 100%;
    margin-bottom: 20px;
    font-size: 0;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;

    img {
        width: 100%;
        height: 248px;
        object-fit: cover;
    }

    .video-info {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 20px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.9) 100%);

        h3 {
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-bottom: 20px;
            margin-top: 30px;
        }

        .video-type {
            display: flex;
            align-items: center;

            .svg-icon {
                width: 24px;
                height: 24px;
                border: 2px solid #FFFFFF;
                border-radius: 50%;
                padding: 4px;
            }

            span {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 19px;
                text-align: left;
                font-style: normal;
                margin-left: 8px;
            }
        }

    }

    &:hover {
        .video-info {
            .video-type {
                .svg-icon {
                    background-color: #E2291E;
                    border-color: #E2291E;
                }

            }
        }
    }
}

.big {
    margin-bottom: 30px;

    img {
        height: 507px;
    }

    .video-info {
        padding-top: 42px;
    }
}

.small {
    img {
        height: 244px;
    }

    .video-info {
        padding-top: 36px;
    }
}

.video-title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 24px;
    color: #2C2C2E;
    line-height: 31px;
    text-align: left;
    font-style: normal;
    margin-top: 16px;
    margin-bottom: 30px;
}

@media screen and (max-width: 768px) {
    .big {
        img {
            height: 224px;
        }
        .video-info{
            padding: 48px 20px 12px 20px;
            .video-type {
                .svg-icon {
                    width: 20px;
                    height: 20px;
                }
                span{
                    font-size: 12px;
                    line-height: 16px;
                }
            }
        }
    }
    .video-item{
        margin-bottom: 12px;
    }
    .video-title{
        font-family: MicrosoftYaHei, MicrosoftYaHei;
font-weight: bold;
font-size: 18px;
color: #2C2C2E;
line-height: 24px;
text-align: left;
font-style: normal;
margin-top: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/common/video-item.vue